import script from "./VitaLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaLoader.vue?vue&type=script&lang=ts&setup=true"

import "./VitaLoader.vue?vue&type=style&index=0&id=1e704d62&lang=scss"

const __exports__ = script;

export default __exports__